import isEmpty from "lodash/isEmpty";
import React from "react";
import { type AssignmentPeopleContext } from "../../../../../enums";
import {
  type PeopleAvailableFlow,
  type WithPeopleContext,
} from "../../../../../features/People/ContentAssignments/models";
import { type Filters } from "../../../../../utils/queryUtils";
import FlowsNoResults from "../../../../../views/library/flows/flowsOverview/FlowsNoResults";
import { CreateFlowButton } from "../../../../../views/library/flows/flowsOverview/FlowsOverviewHeader/CreateFlowButton/CreateFlowButton";
import sortOptions from "../../../../../views/library/flows/flowsOverview/sortOptions";
import { LazyCardsViewerWithHeaderAndPanel } from "../../../../cardsViewer";
import { type CardsViewerItem } from "../../../../cardsViewer/types";
import { FlowFilterForm } from "../../../../filterForms";

import AddToFlowCard from "./addToFlowCard/AddToFlowCard";

export interface ContentListStepProps {
  renderModalActions: (nextStep: () => void, prevStep: () => void) => Function;
  header: string;
  isLoading: boolean;
  isAllLoaded: boolean;
  loadData: () => void;
  items: WithPeopleContext<PeopleAvailableFlow>[];
  itemsCount: number;
  filter: Filters;
  renderSearch: () => React.ReactNode;
  searchValue: string;
  orderBy?: string;
  filterOptions: any;
  applyFilter: (filter: Filters) => void;
  resetFilter: () => void;
  selectedIds: number[];
  onSelectedItemsChanged: (ids: number[]) => void;
  onSortOptionsChanged: (event: React.SyntheticEvent<HTMLElement>, data: { [key: string]: any }) => void;
  accessRestricted: boolean;
  selectedPeopleType: AssignmentPeopleContext;
  blur?: boolean;
}

const ContentListStep = (props: ContentListStepProps) => {
  const {
    blur,
    renderSearch,
    searchValue,
    loadData,
    items,
    itemsCount,
    isLoading,
    isAllLoaded,
    filter,
    selectedIds,
    applyFilter,
    resetFilter,
    filterOptions,
    onSelectedItemsChanged,
    onSortOptionsChanged,
    accessRestricted,
    orderBy,
  } = props;

  return (
    <div className="assignment-grid-step">
      <LazyCardsViewerWithHeaderAndPanel
        blur={blur}
        accessRestricted={accessRestricted}
        renderSearch={renderSearch}
        orderBy={orderBy}
        getData={loadData}
        items={items}
        itemsAmount={itemsCount}
        isLoading={isLoading}
        isAllLoaded={isAllLoaded}
        onSelectedItemsChanged={onSelectedItemsChanged}
        onSortOptionsChanged={onSortOptionsChanged}
        selectedItemIds={selectedIds}
        sortOptions={sortOptions}
        filter={filter}
        filterOptions={filterOptions}
        applyFilter={applyFilter}
        resetFilter={resetFilter}
        hidePopupMenu
        // @ts-ignore
        renderFilterForm={() => <FlowFilterForm />}
        renderCard={(props: CardsViewerItem<WithPeopleContext<PeopleAvailableFlow>>) => {
          return <AddToFlowCard {...props} item={{ ...props.item, isDraft: props.item.published }} />;
        }}
        noResultsContent={
          <FlowsNoResults byCriteria={!isEmpty(filter) || !!searchValue} createFlowButton={<CreateFlowButton />} />
        }
      />
    </div>
  );
};

export default ContentListStep;
